import component from './modal.component';
import confirm from './confirm/confirm.controller';
import cover from './cover/cover.controller';
import info from './info/info.controller';

export default angular.module('mpdx.common.modal', [cover, component, confirm, info]).name;
